import { DATA_SEARCHER } from '../actions/searcher';

const initialState = {
    wordsSearch: '',
    flowFuture: {
      isFuture: false,
      itemClick: {}
    },
    listRanking : {},
};

function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case DATA_SEARCHER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/searcher.js